import * as Yup from "yup";

export const validationSchema = (numConsentCheckboxes) => {
  return Yup.object().shape({
    consent: Yup.array()
      .nullable()
      .test({
        consent: "Consent Required",
        test(values) {
          if (
            !(Array.isArray(values) && values.length === numConsentCheckboxes)
          ) {
            return this.createError({
              path: "consent",
              message: "You must agree to all terms to submit the application.",
            });
          }
          return true;
        },
      }),
  });
};

export const initialValues = {
  consent: [],
};
